import { render, staticRenderFns } from "./zhihuihuanbao.vue?vue&type=template&id=63e73636&scoped=true&"
import script from "./zhihuihuanbao.vue?vue&type=script&lang=js&"
export * from "./zhihuihuanbao.vue?vue&type=script&lang=js&"
import style0 from "./zhihuihuanbao.vue?vue&type=style&index=0&id=63e73636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e73636",
  null
  
)

export default component.exports